import { ref, shallowRef, onMounted } from 'vue'
import { get, setValueByPathToVue, setValueByPath, getValueByPath } from '../../../utils/index'
import { useRoute } from 'vue-router/composables'
import { localStorage } from 'pangu-core'

/***
 * 处理先决条件
 */
export function usePrecondition({
  preconditionFormItemsUrl,
  preconditionFormItems,
  preconditionFormItemsCode,
  preconditionDataInit,
  precondCatch,
}) {
  const preconditionRef = ref(null)
  const preconditionData = ref(preconditionDataInit ?? {})
  const preconditionForm = shallowRef({})

  const getData = async () => {
    if (preconditionFormItems) {
      return preconditionFormItems
    } else if (preconditionFormItemsCode) {
      const [res] = await get(`${preconditionFormItemsUrl}${preconditionFormItemsCode}`)
      return res.data ?? {}
    } else {
      return null
    }
  }

  const route = useRoute()
  const setCatch = () => {
    if (!precondCatch) return
    localStorage.set(`${route.name}_PRECONDITION_DATA`, preconditionData.value)
  }

  const getPreconditionFormItems = async () => {
    const items = await getData()
    const tempItems = Array.isArray(items) ? { items } : items
    preconditionForm.value = tempItems
      ? {
          ...tempItems,
          form: {
            ...tempItems?.form,
            property: {
              colNum: 6, //number，一行展示多少列, 如: 5
              formGroup: false, //Boolean, 是否根据配置的formGroup组件进行分组
              labelPosition: 'left',
              ...tempItems?.form?.property,
            },
          },
        }
      : null
    if (precondCatch) {
      const catchData = localStorage.get(`${route.name}_PRECONDITION_DATA`)
      if (!catchData) return
      const tem = {}
      for (const item of preconditionForm.value.items) {
        if (getValueByPath(catchData, item.property)) {
          setValueByPath(tem, item.property, getValueByPath(catchData, item.property))
        }
      }
      setPreconditionData(tem)
    }
  }

  const setPreconditionData = (data, key) => {
    if (!key) {
      preconditionData.value = data
    } else {
      setValueByPathToVue(preconditionData.value, key, data)
    }
  }

  onMounted(getPreconditionFormItems)

  return {
    preconditionRef,
    preconditionData,
    preconditionForm,
    setPreconditionData,
    setCatch,
  }
}
